"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthExceptions = undefined;

var _ice = require("ice");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `AuthExceptions/Exceptions.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

let AuthExceptions = _ModuleRegistry.module("AuthExceptions");

/**
 * Base for all auth exceptions.
 **/
AuthExceptions.AuthException = class extends _ice.Ice.UserException {
    constructor(message = undefined, _cause = "") {
        super(_cause);
        this.message = message;
    }

    static get _parent() {
        return _ice.Ice.UserException;
    }

    static get _id() {
        return "::AuthExceptions::AuthException";
    }

    _mostDerivedType() {
        return AuthExceptions.AuthException;
    }

    _writeMemberImpl(ostr) {
        _ice.Ice.StringHelper.writeOptional(ostr, 1, this.message);
    }

    _readMemberImpl(istr) {
        this.message = _ice.Ice.StringHelper.readOptional(istr, 1);
    }
};

/**
 * Access token has not been provided in Request Context.
 **/
AuthExceptions.Unauthorized = class extends AuthExceptions.AuthException {
    constructor(message, _cause = "") {
        super(message, _cause);
    }

    static get _parent() {
        return AuthExceptions.AuthException;
    }

    static get _id() {
        return "::AuthExceptions::Unauthorized";
    }

    _mostDerivedType() {
        return AuthExceptions.Unauthorized;
    }
};

/**
 * Token has invalid signature, expired or revoked.
 **/
AuthExceptions.InvalidToken = class extends AuthExceptions.AuthException {
    constructor(message, _cause = "") {
        super(message, _cause);
    }

    static get _parent() {
        return AuthExceptions.AuthException;
    }

    static get _id() {
        return "::AuthExceptions::InvalidToken";
    }

    _mostDerivedType() {
        return AuthExceptions.InvalidToken;
    }
};

/**
 * Token is expired.
 **/
AuthExceptions.TokenExpired = class extends AuthExceptions.InvalidToken {
    constructor(message, _cause = "") {
        super(message, _cause);
    }

    static get _parent() {
        return AuthExceptions.InvalidToken;
    }

    static get _id() {
        return "::AuthExceptions::TokenExpired";
    }

    _mostDerivedType() {
        return AuthExceptions.TokenExpired;
    }
};

/**
 * Token subject is inactive or deleted.
 **/
AuthExceptions.InvalidUser = class extends AuthExceptions.InvalidToken {
    constructor(message, _cause = "") {
        super(message, _cause);
    }

    static get _parent() {
        return AuthExceptions.InvalidToken;
    }

    static get _id() {
        return "::AuthExceptions::InvalidUser";
    }

    _mostDerivedType() {
        return AuthExceptions.InvalidUser;
    }
};

/**
 * Principal doesn't have permission to invoke operation.
 **/
AuthExceptions.Forbidden = class extends AuthExceptions.AuthException {
    constructor(message, _cause = "") {
        super(message, _cause);
    }

    static get _parent() {
        return AuthExceptions.AuthException;
    }

    static get _id() {
        return "::AuthExceptions::Forbidden";
    }

    _mostDerivedType() {
        return AuthExceptions.Forbidden;
    }
};
exports.AuthExceptions = AuthExceptions;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/AuthExceptions/Exceptions.js
// module id = 118
// module chunks = 0